(function () {
  class AccordionScrollbar {
    constructor(contentEl) {
      this.container = contentEl;
      this.inner = contentEl.querySelector('.accordion__inner');
      this.track = contentEl.querySelector('.accordion__scrollbar-track');
      this.thumb = this.track ? this.track.querySelector('.accordion__scrollbar-thumb') : null;

      if (!this.inner || !this.track || !this.thumb) return;

      this.onScroll = this.updateThumbPosition.bind(this);
      this.onResize = this.update.bind(this);

      this.inner.addEventListener('scroll', this.onScroll);
      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this.inner);

      this.update();
    }

    update() {
      if (!this.inner || !this.track || !this.thumb) return;
      const { scrollHeight, clientHeight } = this.inner;
      const hasOverflow = scrollHeight - clientHeight > 1;

      this.track.classList.toggle('is-visible', hasOverflow);
      if (!hasOverflow) {
        this.thumb.style.transform = 'translateY(0)';
        return;
      }

      const trackHeight = this.track.offsetHeight || this.inner.clientHeight;
      const minThumbSize = Math.min(Math.max(trackHeight * 0.15, 12), trackHeight);
      const thumbHeight = Math.max((clientHeight / scrollHeight) * trackHeight, minThumbSize);

      this.thumb.style.height = `${thumbHeight}px`;
      this.maxThumbOffset = Math.max(trackHeight - thumbHeight, 0);
      this.updateThumbPosition();
    }

    updateThumbPosition() {
      if (!this.track || !this.thumb || !this.track.classList.contains('is-visible')) return;
      const { scrollTop, scrollHeight, clientHeight } = this.inner;
      const maxScroll = Math.max(scrollHeight - clientHeight, 1);
      const ratio = scrollTop / maxScroll;
      this.thumb.style.transform = `translateY(${this.maxThumbOffset * ratio}px)`;
    }

    destroy() {
      if (this.inner) {
        this.inner.removeEventListener('scroll', this.onScroll);
      }
      this.resizeObserver?.disconnect();
    }
  }

  const instances = new Map();

  function ensureInstance(el) {
    if (instances.has(el)) return;
    const instance = new AccordionScrollbar(el);
    if (instance?.inner && instance.track && instance.thumb) {
      instances.set(el, instance);
    }
  }

  function cleanupInstances() {
    instances.forEach((instance, el) => {
      if (!document.body.contains(el)) {
        instance.destroy();
        instances.delete(el);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.product__accordion .accordion__content').forEach((el) => ensureInstance(el));
    cleanupInstances();
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);

  const mutationObserver = new MutationObserver(() => {
    initAll();
  });

  mutationObserver.observe(document.body, { childList: true, subtree: true });
})();
